import {
   campaignFlowLive,
   startNewLiveSession,
} from '@forwardflow/features/campaign-flow/services/campaign-flow.live'
import { ICampaignFlowService } from '@forwardflow/features/campaign-flow/services/campaign-flow.service'

/** The screens talk to the real backend through the campaign v2 adapter; there is no demo. */
export const campaignFlowService: ICampaignFlowService = campaignFlowLive

/** Call when "New campaign" starts a fresh draft. */
export const startNewCampaign = () => {
   startNewLiveSession()
}

export type { ICampaignFlowService }
